import { render, staticRenderFns } from "./HeaderBottomEmbed.vue?vue&type=template&id=c8b6aef2&"
import script from "./HeaderBottomEmbed.vue?vue&type=script&lang=ts&"
export * from "./HeaderBottomEmbed.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderBottomEmbed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports